import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import RegisterNanny from "./pages/RegisterNanny";
import RegisterClient from "./pages/RegisterClient";
import Admin from "./pages/Admin";
import Manager from "./pages/Manager";
import Services from "./pages/Services";
import Profile from "./pages/Profile";
import Nanny from "./pages/Nanny";
import List from "./pages/List";
import Portfolio from "./pages/Portfolio";
import AppDescription from "./pages/AppDescription";
import Seeker from "./pages/Seeker";
import NurseAdd from "./pages/NurseAdd";
import NoPermission from "./pages/NoPermission";
import PolitykaPrywatnosci from "./pages/PolitykaPrywatnosci";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { UserDataProvider } from "./components/UserDataContext";
import { UserProvider } from "./components/UserContext";
import { SearchProvider } from "./components/SearchContext";
import Footer from "./components/Footer";
import CookieSettings from "./components/CookieSettings";

const baseUrl = process.env.REACT_APP_BASE_URL || "/";

export const API_URL = "https://twojaopiekunka.pl/api";
export const marginBottom = "4%";
export const marginTop = "4%";

function App() {
  return (
    <UserDataProvider>
      <UserProvider>
        <SearchProvider>
          <div className="app-container">
            <div className="content">
              <BrowserRouter basename={baseUrl}>
                <Routes>
                  <Route path="/" element={<Navigate to="/login" />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/manager" element={<Manager />} />
                  <Route path="/nanny" element={<Nanny />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/seeker" element={<Seeker />} />
                  <Route path="/nurse-add" element={<NurseAdd />} />
                  <Route path="/register/:id" element={<Register />} />
                  <Route path="/registernanny" element={<RegisterNanny />} />
                  <Route path="/registerclient" element={<RegisterClient />} />
                  <Route path="/list" element={<List />} />
                  <Route path="/description" element={<AppDescription />} />
                  <Route path="/cookies" element={<CookieSettings />} />
                  <Route
                    path="/polityka-prywatnosci"
                    element={<PolitykaPrywatnosci />}
                  />
                  <Route path="/portfolio/:id" element={<Portfolio />} />
                  <Route path="/nopermission" element={<NoPermission />} />
                </Routes>
              </BrowserRouter>
            </div>
            <Footer />
          </div>
        </SearchProvider>
      </UserProvider>
    </UserDataProvider>
  );
}

export default App;
